import Stripe from 'stripe';

/**
 * Check if plan is an enterprise plan.
 *
 * Lives outside PlansUtils so leaf components can use it without pulling in
 * PlansUtils' Formatters/API import chain (which breaks module-load order in
 * jest). PlansUtils re-exports it, so both import paths resolve to this one
 * implementation.
 *
 * Mirrors plans.IsEnterpriseKey in
 * backend/lib/services/stripe_cli/plans/plan_eligibility.go, which is the
 * source of truth: legacy IDs carry an "_ent" marker anywhere in the id,
 * catalog prices are prefixed "enterprise" (e.g.
 * enterprise_platform_annual_24000). Go and TypeScript can't share the
 * definition, so enterprisePlan.test.ts pins the same fixtures the Go suite
 * uses — change one side and the other's test fails.
 * @param price stripe price item to check
 */
export const isEnterprisePlan = (price?: Stripe.Price) => {
  const currentPlanId = price?.id;

  return Boolean(
    currentPlanId &&
      (currentPlanId.includes('_ent') ||
        currentPlanId.startsWith('enterprise')),
  );
};
